<template>
  <div>
    <common-dialog
      ref="dialog"
      :width="isMB?'86%':'600px'"
      :title="text"
      :data="data"
      @details-opened="onDetailsOpened"
    >
      <div slot="form" class="my-form">
        <!-- <el-form-item label="流程名称">
          <span>{{data.ProcessName}}</span>
        </el-form-item>-->
        <div class="form-item">
          <div class="i-label">{{data.Title}}</div>
          <div class="i-value">
            <el-tag class="my-tag" style type="primary" v-if="data.InstanceStatus==1">审批中</el-tag>
            <el-tag class="my-tag" type="success" v-if="data.InstanceStatus==2">已通过</el-tag>
            <el-tag class="my-tag" type="danger" v-if="data.InstanceStatus==3">已驳回</el-tag>
            <el-tag class="my-tag" type="info" v-if="data.InstanceStatus==4">已撤销</el-tag>
            <el-tag class="my-tag" type="info" v-if="data.InstanceStatus==5">通过后撤销</el-tag>
            <el-tag class="my-tag" type="danger" v-if="data.InstanceStatus==6">异常</el-tag>
            <el-tag class="my-tag" type="info" v-if="data.InstanceNodeName">
              <span>{{data.InstanceNodeName}}</span>
            </el-tag>
            <el-tag class="my-tag" type="primary" v-if="data.Status==0">待办</el-tag>
            <el-tag class="my-tag" type="success" v-if="data.Status==1">已办</el-tag>
          </div>
        </div>
        <template v-for="(i,key) in data.FormItems">
          <template v-if="i.FuncType > 0">
            <el-form-item :label="i.ItemName" :key="key">
              <template v-if="i.ItemType==400">
                <template v-for="(a,akey) in i.FormItemValue.split('--|--')">
                  <span class="attach" :key="akey" @click="download(a)">{{a.split('--@--')[1]}}</span>
                </template>
              </template>
              <template v-else>
                <span v-if="i.ItemName!='开始时间'&&i.ItemName!='结束时间'">
                  <span>{{i.FormItemValue}}</span>
                  <span v-if="i.ItemName=='请假时长'">天</span>
                </span>
                <span v-else>{{getDatePM(i)}}</span>
              </template>
            </el-form-item>
          </template>
        </template>
        <div style="border-top: 1px solid #DCDFE6"></div>
        <div class="row-head">操作日志</div>
        <el-table :data="data.Logs" border>
          <el-table-column prop="NodeName" label="操作节点" show-overflow-tooltip></el-table-column>
          <el-table-column prop="EmpName" label="操作人" width="75"></el-table-column>
          <el-table-column prop="AddTime" label="操作时间" width="130">
            <template slot-scope="{row}">
              <span v-if="row.Direction==100"></span>
              <span v-else>{{row.AddTime}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Direction" label="操作结果" width="75">
            <template slot-scope="{row}">
              <span v-if="row.Direction==100">待审批</span>
              <template v-else>
                <!-- 审批：同意/驳回/撤销/转审 -->
                <span v-if="row.Direction==0">同意</span>
                <span v-if="row.Direction==1">驳回</span>
                <span v-if="row.Direction==2">撤销</span>
                <span v-if="row.Direction==3">转审</span>
                <span v-if="row.Direction==4">处理</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="Comment" label="操作意见" show-overflow-tooltip></el-table-column>
        </el-table>
        <!-- <el-form-item label="意见">{{data.Comment}}</el-form-item> -->
      </div>
      <template slot="footer">
        <el-button @click="close">取 消</el-button>
      </template>
      <el-dialog title="查看图片" :width="isMB?'90%':''" :visible.sync="imgVisible" append-to-body>
        <img width="100%" :src="imgUrl" alt />
      </el-dialog>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import autoitem from "@/components/wf/common/index";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    autoitem,
  },
  data() {
    return {
      text: "待办信息",
      data: {
        WorkId: null,
        ProcessId: "",
        ProcessName: "",
        Comment: "", //意见
        FormItems: [],
        ApplyDpId: 0,
        ApplyDpName: null,
        ApplyEmpId: null,
        ApplyEmpName: "",
        InstanceId: null,
        Logs: [],
        NextNode: null,
        Node: null,
        NodeId: "",
        NodeName: null,
        OptionalNodes: null,
        ProcessId: "",
        ProcessName: "",
        RejectNodes: null,
        Status: 0,
        InstanceStatus: 0,
        InstanceNodeName: "",
        Title: "",
      },
      isMB: this.$store.state.isMB,
      api: require("@/api/wf/instance").default,
      imgVisible: false,
      imgUrl: "",
    };
  },
  computed: {},
  methods: {
    onDetailsOpened(data) {
      console.log("details", JSON.parse(JSON.stringify(data)));
      this.api.getReadInstance(data.InstanceId, data.NodeId).then((res) => {
        this.data.Logs = res.Data.Logs;
      });
    },
    getDatePM(i) {
      var name = i.ItemName + "部分";
      var item = this.data.FormItems.find((x) => x.ItemName == name);
      return i.FormItemValue + " " + item.FormItemValue;
    },
    onClosed() {},
    download(item) {
      var url = item.split("--@--")[0];
      var name = item.split("--@--")[1];
      var ext_list = name.split(".");
      var ext = ext_list[ext_list.length - 1];
      console.log("name", name);
      console.log("ext", ext);

      if (ext == "jpg" || ext == "png" || ext == "jpeg") {
        this.imgUrl = location.protocol + "//" + location.host + "/api" + url;
        console.log("imgUrl", this.imgUrl);
        this.imgVisible = true;
        return;
      }
      if (ext == "pdf") {
        if (this.chrome) {
          var href = location.protocol + "//" + location.host + "/api" + url;
          window.open(href, "_blank");
          return;
        }
      }

      const elink = document.createElement("a");
      elink.download = name;
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = location.origin + "/api" + url;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
  },
};
</script>
<style lang="scss" scoped>
.my-form {
  .form-item {
    display: flex;
    margin-left: 17px;
    line-height: 28px;
    margin-bottom: 5px !important;
  }
  .el-form-item {
    margin-bottom: 5px !important;
  }
  .attach {
    color: #409eff !important;
    cursor: pointer;
  }
  .attach:not(:last-child)::after {
    content: "、";
  }
}
.logs {
  .log-item {
    line-height: 20px;
  }
}
.my-tag {
  margin-left: 7px;
}
.my-tag + .my-tag {
  margin-left: 7px;
}
</style>